import { injectable } from 'inversify-props'
import { DetalhesPagamentoEmChequeServiceAdapter } from "@/usecases/venda/adapter/DetalhesPagamentoEmChequeServiceAdapter"
import { DetalhesPagamentoEmCheque } from '@/models'
import { criarPagamentoEmCheque, removerPagamentoEmCheque, findByTituloId } from '@/api/detalhesPagamentoEmCheque'

@injectable()
export class DetalhesPagamentoEmChequeService implements DetalhesPagamentoEmChequeServiceAdapter {
	criarPagamentoEmCheque = async (pagamento: DetalhesPagamentoEmCheque) => await criarPagamentoEmCheque(pagamento)
	removerPagamentoEmCheque = async (detalhesPagamentoEmChequeId: string) => await removerPagamentoEmCheque(detalhesPagamentoEmChequeId)
	findByTituloId = async (tituloId: string) => await findByTituloId(tituloId)
}